import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
export const GenericIcon = ({ type, size, fill, x = 0, y = 0 }) => {
    const { Icons } = useContext(ComponentContext);
    const Icon = Icons[type];
    return (React.createElement("svg", { fill: fill, x: x, y: y, style: { color: fill } },
        React.createElement(Icon, { size: size })));
};
//# sourceMappingURL=generic-icon.js.map